import React, { Fragment } from "react";
import { Message } from "semantic-ui-react";
import MsgStore from "stores/MsgStore";
import { observer } from "mobx-react";
import PropTypes from "prop-types";

@observer
export default class MessageBox extends React.Component {
  props: {
    msgStore: MsgStore
  };

  render() {
    const { msgStore } = this.props;
    return (
      <Fragment>
        <ErrorMessage errors={msgStore.errors} />
        {msgStore.info && (
          <Message positive>
            <p>{msgStore.info}</p>
          </Message>
        )}
      </Fragment>
    );
  }
}

const ErrorMessage = ({ errors }) => {
  if (!errors) {
    return null;
  }
  return (
    <Message negative>
      <Message.Header>Error</Message.Header>
      {errors.length === 1 ? (
        <p>{errors[0]}</p>
      ) : (
        <ul style={{textAlign: 'left'}}>{errors.map((el, idx) => <li key={idx}>{el}</li>)}</ul>
      )}
    </Message>
  );
};

ErrorMessage.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string)
};



// WEBPACK FOOTER //
// ./src/components/MessageBox/index.js